/**
 * RecipeBox.jsx — build the whole carousel from a slide list, or copy the
 * current carousel out as the same text.
 */

import { buildRecipe, copyRecipe, setRecipe, useCarousel } from '../../hooks/useCarouselStore';
import { scrollPageTop } from './dom.js';

const PLACEHOLDER = '1. DSC09418\n2. DSC09424 + DSC09433\n3. DJI_0471 | DJI_0494\n4. DSC09504 >> 3\n5. hero: DSC09504, DSC09609, DSC09669, DSC09529';

export default function RecipeBox() {
  const recipe = useCarousel((s) => s.recipe);

  const build = (append) => {
    if (buildRecipe(append)) scrollPageTop(true);
  };

  return (
    <div className="recipe">
      <h3>Build from a slide list</h3>
      <p>
        One line per slide. <code className="k">+</code> stacks two photos, <code className="k">|</code> puts them side by side,{' '}
        <code className="k">&gt;&gt; 3</code> spreads one wide photo across three seamless slides,{' '}
        <code className="k">hero: A, B, C, D</code> puts A across the top, B tall on the left and C over D on the right
        (<code className="k">hero 50%:</code> sets the top height), and any shape from Layouts… names itself the same way —{' '}
        <code className="k">grid-quarter: A, B, C, D</code>. Numbering, blank lines and <code className="k">#</code> comments
        are ignored. Partial filenames are fine — <code className="k">9418</code> finds <code className="k">DSC09418.jpg</code>.
      </p>
      <textarea
        spellCheck={false}
        placeholder={PLACEHOLDER}
        value={recipe}
        onChange={(e) => setRecipe(e.target.value)}
        aria-label="Slide list"
      />
      <div className="recipe-actions">
        <button type="button" className="btn" onClick={() => build(false)}>Build slides</button>
        <button type="button" className="btn ghost" onClick={() => build(true)}>Append to existing</button>
        <button type="button" className="btn ghost" onClick={copyRecipe}>Copy current layout as text</button>
      </div>
    </div>
  );
}
